<template>
  <div id="audio">
    <link rel="preload" href="../assets/sounds/${name}.mp3" as="audio"/>

    <audio
        :loop="innerLoop"
        ref="audiofile"
        preload="auto"
        style="display: none"
    ></audio>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

const convertTimeHHMMSS = (val) => {
  let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);

  return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
};

export default {
  props: {
    autoPlay: {
      type: Boolean,
      default: true,
    },
    loop: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    audioElementListenersSet: false,
    audio: undefined,
    currentSeconds: 0,
    durationSeconds: 0,
    innerLoop: false,
    loaded: false,
    playing: false,
    previousVolume: 35,
    volume: 100,
  }),
  computed: {
    sound: {
      get: function () {
        return this.file;
      },
      set: function (name) {
        this.audio.src = require(`../assets/sounds/${name}.mp3`);
      },
    },

    currentTime() {
      return convertTimeHHMMSS(this.currentSeconds);
    },
    durationTime() {
      return convertTimeHHMMSS(this.durationSeconds);
    },
    muted() {
      return this.volume / 100 === 0;
    },
    ...mapGetters(["getEventSoundByName"]),
  },
  watch: {
    volume(value) {
      if (!this.audio) return
      this.audio.volume = this.volume / 100;
    },
    audioElementListenersSet(v) {
      if (!v) return

      this.audio.volume = this.volume / 100;
    }
  },
  methods: {
    changeSound(name, isSoundName = false) {
      let newSoundName = isSoundName ? name : this.getEventSoundByName(name);
      let soundIsCached = false;
      if ('caches' in window) {

        new Promise(async function (resolve, reject) {
          await caches
              .open("dealio-cache-v" + process.env.PACKAGE_VERSION)
              .then(async (cache) => {
                await cache.keys().then(function (keys) {
                  if (keys.some((key) => key.url.includes(newSoundName))) {
                    soundIsCached = true;
                  }
                });
              });
          resolve();
        }).then(() => {
          let connectionLost = localStorage.getItem("connection-lost");
          if (connectionLost != null) connectionLost = parseInt(connectionLost)
          if (
              connectionLost != null &&
              connectionLost
          ) {
            if (soundIsCached) {
              this.stop();
              this.sound = newSoundName;
            }
          } else {
            this.stop();
            this.sound = newSoundName;
          }
        });
      }
    },
    audioEventListenersState() {
      return this.audioElementListenersSet;
    },
    addAudioElementListeners() {
      this.audio = document.getElementById("my-audio"); //  this.$el.querySelectorAll("audio2")[0];
      if (this.audio != null) {
        this.audio.addEventListener("timeupdate", this.update);
        this.audio.addEventListener("loadeddata", this.load);
        this.audio.addEventListener("pause", () => {
          this.playing = false;
        });
        this.audio.addEventListener("play", () => {
          this.playing = true;
        });
        this.audioElementListenersSet = true;
      } else {
        this.audioElementListenersSet = false;
      }
    },
    async play(name) {
      this.changeSound(name);
    },
    playSound(name) {
      this.changeSound(name, true);
    },
    download() {
      this.stop();
      window.open(this.file, "download");
    },
    load() {
      if (this.audio.readyState >= 2) {
        this.loaded = true;
        this.durationSeconds = parseInt(this.audio.duration);
        if (this.autoPlay) {
          this.audio.play().catch((exception) => {
            console.error(
                `Could not play sound reason: ${exception}. Will try once more..`
            );
            this.audio.play();
          });
        }
        return (this.playing = this.autoPlay);
      }

      throw new Error("Failed to load sound file.");
    },
    mute() {
      if (this.muted) {
        return (this.volume = this.previousVolume);
      }

      this.previousVolume = this.volume;
      this.volume = 0;
    },
    stop() {
      this.playing = false;
      this.audio.currentTime = 0;
    },
    update(e) {
      this.currentSeconds = parseInt(this.audio.currentTime);
    },
  },
  created() {
    this.innerLoop = this.loop;
  },
  mounted() {
    this.addAudioElementListeners();
  },
};
</script>
